import Duck from "redux-ducks-ts"

export const event = new Duck("event", "cargo")
